<template>
   <CardUploadFiles
      :isVisiblePrimary="false"
      :titleCard="'Precisamos verificar uma selfie de sua CNH ao lado de seu rosto'"
      :cardDescription="'selfie_cnh'"
      :textCard="'Selfie com a CNH'"
      :textCardAttention="'O documento precisa estar no nome do titular'"
      :srcExampleImage="IconDocument"
      :nextRoute="'UploadCrlv'"
      :previewScreen="'PreviewDocumentationFiles'"
   />
</template>
<script>
import CardUploadFiles from '../../components/CardUploadFiles.vue'
import FooterButton from '../../components/FooterButton.vue';
import IconDocument from '../../../../public/images/illustration-document.svg'

export default {
components: {
   CardUploadFiles,
   FooterButton
},
setup() {
   return {
       IconDocument
   };
 },
}
</script>